import React from 'react';
import {Navigate, useLocation} from "react-router-dom";

const PrivateRoute = ({children, ...options}) => {
    const location = useLocation();
    const hasToken = localStorage.getItem('token');
    return hasToken ? children : <Navigate to={'/sign-in'} state={{ from: location }}/>;
};

export default PrivateRoute;